const HIGHLIGHT_CLASS = 'ring-2 ring-hxd-orange ring-offset-2';

/** Scroll to a hash target (`article-{id}` or pillar slug). */
export function scrollToBriefTarget(hash, { highlight = true, updateHash = true } = {}) {
  const raw = (hash || '').replace(/^#/, '');
  if (!raw) return;

  if (updateHash && typeof window !== 'undefined') {
    const next = `#${raw}`;
    if (window.location.hash !== next) {
      window.history.replaceState(null, '', next);
    }
  }

  const el = document.getElementById(raw);
  if (!el) return;

  el.scrollIntoView({ behavior: 'smooth', block: 'start' });

  if (highlight) {
    el.classList.add(HIGHLIGHT_CLASS);
    const heading = el.querySelector('h3');
    if (heading && typeof heading.focus === 'function') {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
    window.setTimeout(() => el.classList.remove(HIGHLIGHT_CLASS), 2000);
  }
}
